import React, { useMemo } from 'react';
import { useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { SectionTabs } from '../../component/common/designSystem';
import eliteGameRoutes from '../../routes/eliteGameRoute.js';
import { Helmet } from 'react-helmet';
import { EliteGamesProvider, useEliteGames } from '../../context/EliteGamesContext.js';
import Loader from '../../component/common/Loader.js';
import Topbar from '../../component/EliteGame/topbar.jsx';
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

// Inner component that can access the context
const EliteGamesContent = () => {
  const location = useLocation();
  const { loading } = useEliteGames(); // Get loading state from context

  const userData = JSON.parse(localStorage.getItem('userData'));

  const navigationItems = [
    {
      name: 'Quiz Zone',
      isDropDown: true,
      subMenu: [
        {
          name: 'Main Category',
          href: '/game/quizZone/main-category'
        },
        {
          name: 'Sub Category',
          href: '/game/quizZone/sub-category'
        },
        {
          name: 'Category Order',
          href: '/game/quizZone/category-order'
        },
        {
          name: 'Manage Questions',
          href: '/game/quizZone/manage-questions'
        },
        {
          name: 'Import Questions',
          href: '/game/quizZone/import-questions'
        }
        // {
        //   name: 'Question Reports',
        //   href: '/game/quizZone/question-reports'
        // }
      ]
    },
    {
      name: 'Daily Quiz',
      isDropDown: true,
      subMenu: [
        {
          name: 'Manage Questions',
          href: '/game/daily-quiz/manage-questions'
        },
        {
          name: 'Import Questions',
          href: '/game/daily-quiz/import-questions'
        }
      ]
    },

    {
      name: 'Multi Match',
      isDropDown: true,
      subMenu: [
        {
          name: 'Main Category',
          href: '/game/multi-match/mainCategory'
        },
        {
          name: 'Sub Category',
          href: '/game/multi-match/subcategory'
        },
        {
          name: 'Category Order',
          href: '/game/multi-match/category-order'
        },
        {
          name: 'Manage Questions',
          href: '/game/multi-match/manage-questions'
        },
        {
          name: 'Import Questions',
          href: '/game/multi-match/import-questions'
        }
        // {
        //   name: 'Question Reports',
        //   href: '/game/multi-match/question-reports'
        // }
      ]
    },
    // {
    //   name: 'Contests',
    //   isDropDown: true,
    //   subMenu: [
    //     {
    //       name: 'Manage Contest',
    //       href: '/game/contest/manage-contest'
    //     },
    //     {
    //       name: 'Manage Questions',
    //       href: '/game/contest/manage-questions'
    //     },
    //     {
    //       name: 'Import Questions',
    //       href: '/contest-questions-import'
    //     }
    //   ]
    // },
    {
      name: 'Fun & Learn',
      isDropDown: true,
      subMenu: [
        {
          name: 'Main Category',
          href: '/game/fun-n-learn/maincategory'
        },
        {
          name: 'Sub Category',
          href: '/game/fun-n-learn/subcategory'
        },
        {
          name: 'Category Order',
          href: '/game/fun-n-learn/category-order'
        },
        {
          name: 'Manage Questions',
          href: '/game/fun-n-learn/manage-questions'
        },
        {
          name: 'Manage Fun & Learn',
          href: '/game/fun-n-learn/create-n-manage'
        },
        {
          name: 'Import Questions',
          href: '/game/fun-n-learn/import-questions'
        }
      ]
    },
    {
      name: 'Guess The Word',
      isDropDown: true,
      subMenu: [
        {
          name: 'Main Category',
          href: '/game/guess-the-word-category'
        },
        {
          name: 'Sub Category',
          href: '/game/guess-the-word/subcategory'
        },
        {
          name: 'Category Order',
          href: '/game/guess-the-word/category-order'
        },
        {
          name: 'Manage Questions',
          href: '/game/guess-the-word/manage-questions'
        },
        {
          name: 'Import Questions',
          href: '/game/guess-the-word/import-questions'
        }
      ]
    },
    // {
    //   name: 'Audio Questions',
    //   isDropDown: true,
    //   subMenu: [
    //     {
    //       name: 'Main Category',
    //       href: '/game/audio-questions-category'
    //     },
    //     {
    //       name: 'Sub Category',
    //       href: '/game/audio-questions/subcategory'
    //     },
    //     {
    //       name: 'Category Order',
    //       href: '/game/audio-questions/category-order'
    //     },
    //     {
    //       name: 'Manage Questions',
    //       href: '/game/audio-questions/manage-questions'
    //     }
    //   ]
    // },
    {
      name: 'Maths Quiz',
      isDropDown: true,
      subMenu: [
        {
          name: 'Main Category',
          href: '/game/maths-quiz-category'
        },
        {
          name: 'Sub Category',
          href: '/game/maths-quiz-subcategory'
        },
        {
          name: 'Category Order',
          href: '/game/maths-quiz/category-order'
        },
        {
          name: 'Manage Questions',
          href: '/game/maths-quiz/manage-questions'
        },
        {
          name: 'Import Questions',
          href: '/game/maths-quiz/import-questions'
        }
      ]
    },
    // {
    //   name: 'Exam Module',
    //   isDropDown: true,
    //   subMenu: [
    //     {
    //       name: 'Exam Module',
    //       href: '/game/exam-module/mainCategory'
    //     },
    //     {
    //       name: 'Import Exam Questions',
    //       href: '/game/exam-module/exam-import-questions'
    //     },
    //     {
    //       name: 'Manage Exam Questions',
    //       href: '/game/exam-module/exam-manage-questions'
    //     }
    //   ]
    // },
    {
      name: 'Leaderboard',
      href: '/game/leaderboard/all'
      // subMenu: [
      //   {
      //     name: 'All',
      //     href: '/game/leaderboard/all'
      //   },
      //   {
      //     name: 'Monthly',
      //     href: '/game/leaderboard/monthly'
      //   },

      //   {
      //     name: 'Daily',
      //     href: '/game/leaderboard/daily'
      //   }
      // ]
    }
    // {
    //   name: 'Settings',
    //   href: '/game/settings'
    // }
  ];

  /**
   * A game's routes do not share one tidy prefix — Guess The Word owns both
   * `/game/guess-the-word-category` and `/game/guess-the-word/subcategory` —
   * so the scope that decides which game tab is lit is the longest string all
   * of its hrefs start with. That also covers routes absent from the tab row,
   * such as `/game/quizZone/view-questions`, which would otherwise light
   * nothing while you are plainly still inside Quiz Zone.
   */
  const commonPrefix = (paths) =>
    paths.reduce((prefix, path) => {
      let index = 0;
      while (index < prefix.length && prefix[index] === path[index]) index += 1;
      return prefix.slice(0, index);
    }, paths[0] || '');

  const games = useMemo(
    () =>
      navigationItems.map((item) => {
        const subMenu = item.subMenu || [];
        const href = item.href || subMenu[0]?.href;
        return {
          label: item.name,
          path: href,
          scope: subMenu.length ? commonPrefix(subMenu.map((sub) => sub.href)) : href,
          subMenu
        };
      }),
    // navigationItems is rebuilt each render but never varies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const activeGame = games.reduce((best, game) => {
    if (!location.pathname.startsWith(game.scope)) return best;
    return !best || game.scope.length > best.scope.length ? game : best;
  }, null);

  const sectionTabs = (activeGame?.subMenu || []).map((sub) => ({
    label: sub.name,
    path: sub.href
  }));

  return (
    <div className="min-h-screen ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Games</title>
      </Helmet>
      {/* Horizontal Navigation Header */}
      <div className="">
        <div className=" mx-4 shadow-sm border-b">
          <div className="flex justify-between items-center py-4">
            <Topbar title={activeGame?.label || 'Elite Games'} />
          </div>

          {/* The pages inside the selected game. Picking the game itself is
              the sidebar's job now; these were a dropdown hanging off a pill
              button, and they are routes, so they read as tabs like every
              other section. */}
          {sectionTabs.length > 0 ? (
            <SectionTabs tabs={sectionTabs} className="pb-1" />
          ) : (
            <div className="pb-4" />
          )}

          {/* <div className="text-base flex justify-center gap-x-1 items-center text-shoorah-newDashboardBlue2 dark:text-shoorah-darkBg">
            <Menu className="relative" as="div">
              <Menu.Button className="flex items-center justify-center text-sm font-medium focus:outline-none w-[18px] h-[18px] rounded-full border border-black mt-2">
                <ChevronDownIcon className="w-[14px] text-shoorah-lightBlack" />
              </Menu.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Menu.Items className="absolute w-[150px] shadow-lg bottom-0 left-[2rem] -translate-x-full translate-y-full z-10 mt-2 rounded-md dark:bg-shoorah-darkBgColor bg-white ring-1 ring-shoorah-primary ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    <Menu.Item>
                      {({ active }) => (
                        <Link
                          to={
                            !isSuperAdmin()
                              ? userData?.userType === 5
                                ? '/change-password'
                                : `/${userData.slug}/change-password`
                              : '/change-password'
                          }
                          className={classNames(
                            active
                              ? 'bg-gray-100 dark:text-shoorah-darkBg text-shoorah-sidebarBackground'
                              : ' dark:text-shoorah-darkBg text-gray-700',
                            'block px-4 py-2 whitespace-nowrap text-sm hover:bg-inherit'
                          )}
                        >
                          Change Password
                        </Link>
                      )}
                    </Menu.Item>
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          </div> */}
        </div>
      </div>

      {/* Main Content Area for Child Routes */}
      <main className="flex-1">
        <div className="">
          {loading && <Loader />}
          <Routes>
            {/* Default redirect when accessing /game */}
            <Route index element={<Navigate to="/game/quizZone/main-category" replace />} />
            {eliteGameRoutes.map((route, index) => (
              <Route key={index} path={route.path} element={<route.component />} />
            ))}
          </Routes>
        </div>
      </main>
    </div>
  );
}; // Main component that wraps content with provider
const EliteGames = () => {
  return (
    <EliteGamesProvider>
      <EliteGamesContent />
    </EliteGamesProvider>
  );
};

export default EliteGames;
